import { useDispatch, useSelector } from 'react-redux';
import { selectAppAuth, selectAppAuthToken, setOriginLocation } from '../../services/auth/authSlice';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { checkUserFields, selectUserInfo } from '../User/userSlice';
import LoaderScreen from '../../screens/RootScreen/LoaderScreen';

export const ProtectedRoute = ({
  redirectPath = '/login',
  blockedPath = '/no_access',
  blockedPathInternal = '/no_access_internal',
  waitingPath = '/login/waiting_approval',
  onboardingPath = '/login/onboarding',
  permission = "",
  level = 0,
  is_super_admin = false,
  children,
}) => {
    const userAuth = useSelector(selectAppAuth)
    const userInfo = useSelector(selectUserInfo)
    const missingFields = useSelector(checkUserFields)
    const location = useLocation()
    const dispatch = useDispatch()

    useEffect(()=>{
      dispatch(setOriginLocation(location.pathname))
    },[])

    if ((!userAuth.auth_token && userAuth.refresh_auth) || (userAuth.auth_token && (!userInfo.user_data || !userInfo.user_fields))) {
      return <LoaderScreen />;
    } else if (!userAuth.auth_token ) {
        return <Navigate to={redirectPath} replace />;
    } else if (userInfo?.user_data && userAuth.auth_token && userInfo?.user_data?.is_admin !== true && location.pathname !== '/no_access') {
        return <Navigate to={blockedPath} replace />;
    } else if (userInfo?.user_data && userAuth.auth_token && ( userAuth.admin_check_required || userInfo?.user_data?.state === "waiting_admin_check")) {
        return <Navigate to={waitingPath} replace />;
    } else if (userInfo?.user_data && (permission !== "") && (!userInfo?.user_data?.permissions[permission] || !userInfo?.user_data?.permissions[permission]?.level < level) ) {
        return <Navigate to={blockedPathInternal} replace />;
    } else if (userInfo?.user_data && is_super_admin && (!userInfo?.user_data?.is_super_admin)) {
        return <Navigate to={blockedPathInternal} replace />;
    } else if (userInfo?.user_data && userInfo?.user_fields && (missingFields || !userInfo?.user_data?.legal_checks?.external_legal_check) && userInfo?.user_data?.state !== "waiting_admin_check" && location.pathname !== '/login/onboarding')
      return <Navigate to={onboardingPath} replace />; 
    else if (userInfo?.user_data)
      return children ? children : <Outlet />;
};